package com.cybersoftsolution.cybersoftsolutionweb.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient


@Serializable
actual data class SimplePost(
    @SerialName("_id")
    actual override var id:String? = null,
    actual var userName:String? = null,
    actual var date:Long? = null,
    actual var title:String? = null,
    actual var subtitle:String? = null,
    actual var image:String? = null,
    actual var category:Category? = null,
    @Transient
    actual override var selected:Boolean = false
    ):MyElement()

